import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../../../../util/reactIntl';
import classNames from 'classnames';

import css from './ForProfessionals.module.css';

const professionalList = [
    {
        title: "Get started",
        description: "Create your profile and get matched with jobs that are right for you."
    },
    {
        title: "Get noticed",
        description: "Clients will be able to invite you to their projects."
    },
    {
        title: "Get jobs",
        description: "Get hired directly through our platform."
    },
]

const SectionProfessionalFeatures = props => {
    const { rootClassName, className } = props;

    const classes = classNames(rootClassName || css.root, className);

    return (
        <div className={classes}>
            <div className={css.content}>
                <div className={css.upperContent}>
                    <div className={css.subTitle}>
                        For professionals
                    </div>
                </div>
                <div className={css.bottomContent}>
                    <div className={css.title}>
                        Communicate and arrange work directly with clients
                    </div>
                    <div className={css.cards}>
                        {professionalList.map((item, i) => {
                            return (
                                <div className={css.card} key={i}>
                                    <h2 className={css.cardTitle}>
                                        {item.title}
                                    </h2>
                                    <p className={css.cardText}>
                                        {item.description}
                                    </p>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </div>
        </div>
    );
};

SectionProfessionalFeatures.defaultProps = { rootClassName: null, className: null };

const { string } = PropTypes;

SectionProfessionalFeatures.propTypes = {
    rootClassName: string,
    className: string,
};

export default SectionProfessionalFeatures;
